import React from 'react';
import classNames from 'classnames/bind';

import { Button } from '@components';

import styles from './AddToCartButton.module.scss';

const CN = 'add-to-cart-button';
const quickCartClassName = `${CN}--quick-cart`;

const cx = classNames.bind(styles);

interface AddToCartButtonProps {
  isOnStock?: boolean;
  onClick: () => void;
  isLoading: boolean;
  quickCart?: boolean;
  className?: string;
  buttonText?: string;
  disabled?: boolean;
}

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  isOnStock,
  isLoading,
  onClick,
  quickCart = false,
  buttonText = 'Add To Bag',
  disabled,
  className
}) => (
  <Button
    loading={ isLoading }
    onClick={ onClick }
    disabled={ disabled || !isOnStock }
    className={ cx(className, quickCart ? quickCartClassName : CN) }
  >
    { isOnStock ? buttonText : 'Out Of Stock'}
  </Button>
);
